module.exports = __webpack_public_path__ + "static/media/meade.db494044.png";